module.exports = __webpack_public_path__ + "img/Weapon_130.2eeb6ec0.png";